export default __webpack_public_path__ + "static/media/route_optimize.0597b614.svg";